import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useQuickEnquiry } from "@/hooks/QuickEnquiryContext";
import logo from "./bollywoodfirki.png"

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Artists", path: "/artists" },
  { label: "YouTube", path: "/youtube-network" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
];

interface NavbarProps {
  activePage?: string;
}

export default function Navbar({ activePage }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { openEnquiry } = useQuickEnquiry();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav style={{background:"transparent"}} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-[#0d0d0d]/95 backdrop-blur-md border-b border-[#d4af37]/20" : "bg-[#0d0d0d]/95 backdrop-blur-md border-b border-[#d4af37]/20"}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 flex-shrink-0">
          <img
            alt="Bollywood Firki Logo"
            className="h-12 md:h-12 w-auto object-contain logooo"
            src={logo}
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors duration-200 relative group whitespace-nowrap ${
                isActive(link.path) ? "text-[#d4af37]" : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
              <span
                className={`absolute -bottom-1 left-0 h-0.5 bg-[#d4af37] transition-all duration-300 ${
                  isActive(link.path) ? "w-full" : "w-0 group-hover:w-full"
                }`}
              />
            </Link>
          ))}
        </div>

        {/* CTA buttons */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => openEnquiry()}
            className="flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold text-white whitespace-nowrap bg-green-500 hover:bg-green-600 transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base" />
            Quick Enquiry
          </button>
          <Link
            to="/contact"
            className="flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-black whitespace-nowrap transition-all duration-300 hover:scale-105 btn-gold"
          >
            Get Started <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0d0d0d]/98 border-t border-[#d4af37]/10 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                isActive(link.path) ? "text-[#d4af37] bg-[#d4af37]/10" : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <button
            onClick={() => { openEnquiry(); setMenuOpen(false); }}
            className="mt-1 py-3 rounded-full text-sm font-semibold text-white whitespace-nowrap text-center bg-green-500 hover:bg-green-600 transition-all cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-whatsapp-line"></i> Quick Enquiry
          </button>
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="py-3 rounded-full text-sm font-semibold text-black whitespace-nowrap text-center btn-gold"
          >
            Get Started
          </Link>
        </div>
      )}
    </nav>
  );
}